<template>
  <div class="page white_bg">
    <div class="centered" style="max-width: 375px;">
      <div class="header headerIcon">
        <div class="backIconArea">
          <span class="icon leftAngleBracketIcon floatL backIcon" @click="back();"></span>
        </div>
        <div class="q_title">{{ dataItem.title || '' }}</div>
        <div class="q_introduction">{{ dataItem.introduction || '' }}</div>
      </div>
      <div class="questionList">
        <!-- {{dataItem}} -->
        <div class="questionItem" v-for="(q_item, i) in dataItem.questionList" :key="i">
          <div style="display: flex">
            <div class="questionTitle">{{ q_item.title || "" }}</div>
            <span v-if="q_item.multipleChoice" class="icon multiple"></span>
          </div>
          <div class="answerItem" v-for="(g_item, o) in q_item.groupAnswerList" :key="o">
            <div>
              <div class="answerType" v-if="g_item.groupName">{{ g_item.groupName }}</div>
              <div class="tagOption">
                <span class="areaTag" @click="selectedItem(q_item.multipleChoice, a_item, i)"
                  v-for="(a_item, p) in g_item.answerList" :key="p"
                  :class="{ active: existElement(a_item, q_item.checkList)}">{{ a_item.title || "" }}</span>
              </div>
              <div class="textOption" v-if="q_item.textShow">
                <textarea v-model="q_item.textValue"
                  style="width: 333px;max-width: 333px;min-width: 333px;font-size: 14px;height: 26px;border: 1px solid #8994a9;border-radius: 4px"></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="operationArea white_bg" style="height: 48px; padding-bottom: 34px">
        <div class="generalPagePaddingH" style="padding-top: 6px">
          <div class="flexLayout">
            <button class="button block submitBtn" @click="submit" :disabled="!isAnswered">
              {{ isAnswered ? '提交' : '您已填写过啦！' }}
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import shixunPagePart from '@/components/shixunApp/shixunPagePart';

import requestManager from "@comp/platformApi/requestManager";
// config
import appConfig from '../../appConfig';

import storageManager from '@comp/platformApi/storageManager';

// util
import dataMixedUtils from "@util/dataMixedUtils";
import appHelper from '@util/appHelper';

const config = {
  apiConfig: {
    get: {
      url: '/portal/questionnaire/v2/getOpinionQuestionnaire',
      method: 'get',
    },
    post: {
      url: '/portal/questionnaire/v2/fillInQuestionnaire',
      method: 'post',
    },
    isOpinionQuestionnaire: {
      url: '/portal/questionnaire/v2/isAbleFileIn/opinionQuestionnaire',
      method: 'get',
    },
  },
  demoTitleList: [
    '园长“苦恼”，幼儿园之间到底在竞争什么',
    '如何使运营的微信公众号活跃起来？',
    '做好这几点，让园区摆脱对名师的依赖'
  ]
};

export default {
  name: "questionnaire",
  extends : shixunPagePart,
  components: {},
  data () {
    return {
      title: '问卷调查',
      dataMixedUtils: dataMixedUtils,
      apiConfig: config.apiConfig,
      // pageSize : 8,
      autoLoadData: appConfig.mode != 'demo',
      selectItemList: [],
      dataItem: {},
      isAnswered: false
    }
  },
  methods: {
    loadQuestionnaire () {
      let options = this.apiConfig.get;
      requestManager.request(options, (error, result) => {
        if (error) {
          appHelper.generalAjaxError(error);
          return;
        }

        let errorCode = result.errorCode;
        if (errorCode) {
          appHelper.showMessage(result.msg);
          return;
        }
        this.dataItem = result.data;
        appHelper.setTitle(this.dataItem.title);
        this.reloadDataItem();
      });
    },
    submit () {
      let data = this.questionValueFormat();
      if (!data) {
        return;
      }
      let options = this.apiConfig.post;
      options.data = { dto: JSON.stringify(data) };
      requestManager.request(options, (error, result) => {
        if (error) {
          appHelper.generalAjaxError(error);
          return;
        }
        let errorCode = result.errorCode;
        if (errorCode) {
          appHelper.showMessage(result.msg);
          return;
        }
        appHelper.showMessage("提交成功", "感谢您的反馈！");
        this.isAlreadyAnswered();

        let prevPageUrl = storageManager.getItem('prevPageUrl') || '';
        if (prevPageUrl) {
          appHelper.redirect(prevPageUrl);
        }

      });
    },
    questionValueFormat () {
      let q_list = this.dataItem.questionList;
      console.log(q_list);
      let a_lsit = [];
      for (let i = 0; i < q_list.length; i++) {
        let answerList = q_list[i].checkList;
        a_lsit.push({
          questionId: q_list[i].id
        })
        if (q_list[i].required) {
          if (answerList && answerList.length) {
            a_lsit[i].userAnswerList = [];
            for (let o = 0; o < answerList.length; o++) {
              if (q_list[i].required) {
                if (answerList[o].type == 3 || answerList[o].type == 4 ||
                  (answerList[o].type == 1 && answerList[o].title == '其他')) {
                  if (!q_list[i].textValue) {
                    appHelper.showMessage("必填项", "请填写 " + q_list[i].title + " 的内容！");
                    return false;
                  }
                }
              }
              a_lsit[i].userAnswerList.push({
                answerId: answerList[o].id,
                value: q_list[i].textValue || ''
              })
            }

          } else {
            appHelper.showMessage("必选项", "请选择 " + q_list[i].title);
            return false;
          }
        }
      }
      let data = {
        questionnaireId: this.dataItem.id,
        userQuestionList: a_lsit
      };
      return data;
    },
    isAlreadyAnswered () {
      let options = this.apiConfig.isOpinionQuestionnaire;
      requestManager.request(options, (error, result) => {
        if (error) {
          appHelper.generalAjaxError(error);
          return;
        }

        let errorCode = result.errorCode;
        if (errorCode) {
          appHelper.showMessage(result.msg);
          return;
        }
        if (!result.data) {
          appHelper.showMessage("提示", "您已经填写过此问卷啦！");
        }
        this.isAnswered = result.data;
      });
    },
    selectedItem (multiple, selectTtem, i) {
      let checkGroup = this.dataItem.questionList[i];
      if (multiple) {
        if (checkGroup.checkList) {
          if (!checkGroup.checkList.length) {
            checkGroup.checkList = [];
          }
        } else {
          checkGroup.checkList = [];
        }
        if (this.existElement(selectTtem, checkGroup.checkList)) {
          checkGroup.checkList = this.removeElement(
            checkGroup.checkList,
            selectTtem
          );
        } else {
          checkGroup.checkList.push(selectTtem);
        }
      } else {
        checkGroup.checkList = [selectTtem];
        if (selectTtem.type === 3 || selectTtem.type === 4 || (selectTtem.type === 1 && selectTtem.title == '其他')) {
          checkGroup.textValue = '';
          checkGroup.textShow = true;
        } else {
          checkGroup.textValue = '';
          delete checkGroup["textShow"];
        }
      }
      this.$set(this.dataItem.questionList, i, checkGroup);
    },
    existElement: function (value, array) {
      if (array && array.length) {
        for (let i = 0; i < array.length; i++) {
          if (array[i] === value) {
            return true;
          }
        }
      }
      return false;
    },
    removeElement: function (array, element) {
      let newArray = [];

      for (let i = 0; i < array.length; i++) {
        if (array[i] === element) {
          continue;
        }

        newArray.push(array[i]);
      }

      return newArray;
    },
  },
  mounted () {

    this.loadQuestionnaire();
    this.isAlreadyAnswered();
  }
}
</script>

<style lang="scss" scoped>
.header {
  height: 205px;
  width: 375px;
  .backIconArea {
    width: 100%;
    height: 44px;
    .backIcon {
      width: 22px;
      height: 22px;
      margin: 11px 0px 0px 16px;
    }
  }
  .q_title {
    width: fit-content;
    height: 24px;
    font-size: 24px;
    font-weight: 500;
    color: #484848;
    margin: 18px 0 0 16px;
  }
  .q_introduction {
    width: 327px;
    height: 34px;
    font-size: 13px;
    font-weight: 400;
    line-height: 21px;
    color: #5b616c;
    margin: 18px 0 0 16px;
  }
}

.questionList {
  padding: 0 18px;
  margin-bottom: 122px;
  .questionItem {
    margin-top: 20px;
    &:first-child {
      margin-top: 0px;
    }
    .questionTitle {
      width: fit-content;
      height: 16px;
      font-size: 16px;
      font-weight: 500;
      color: #484848;

    }
    .answerItem {
      margin-top: 21px;
      .answerType {
        margin: 12px 0 8px 1px;
        width: fit-content;
        font-size: 14px;
        font-weight: 400;
        color: #5b616c;

        .textOption {
          width: 100%;
          height: auto;
        }
      }
    }
  }
}

.operationArea {
  position: fixed;
  bottom: 0;
  .submitBtn {
    width: 339px;
    height: 36px;
    background: #ffa724;

    border-radius: 24px;
    color: #ffffff;
    &:disabled {
      background: #666666;
    }
  }
}
.areaTag {
  display: inline-block;
  //width: 68px;
  height: 26px;
  line-height: 26px;
  //padding: 0 20px;
  padding: 0 14px;
  background: #f2f3f8;
  border-radius: 4px;
  text-align: center;
  color: #5b616c;
  font-size: 14px;
  margin-right: 12px;
  margin-bottom: 12px;
  border: 1px solid #fff;
  &.active {
    background: #fff8e8;
    color: #ffa724;
    border: 1px solid #ffa724;
  }
}

.headerIcon {
  height: 205px;
  width: 375px;
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAXcAAADNCAYAAABD5jBZAAAgAElEQVR4Xu2dCZQcxZ3mv6jMquqr+j7U3boPdKADqYVAsFjiFMbG4EM+xmADMysfrHn2ztrj2Zl9K+yZ9Y4HPG/Hb3bGrD3etXd3ZoSNF2NAXBb4wANIgAUIDFgSUutstaRWn3Vkxb7IoyqqurrVR1VJZH75eE/dVZER+f9F8uXX//xnpJBP3nYxuJEACZAACfiKgEhQ3H01oQyGBEiABBQBIXfcsZYoSIAESIAE/EVAyB23Utz9NaeMhgRIgAQg5OMUd54HJEACJOA3AkL+/NNdfguK8ZAACZBA0AlQ3IN+BjB+EiABXxKguPtyWhkUCZBA0AkI+dTta4IOgfGTAAmQgN8ICPnULRR3v80q4yEBEgg8AYp74E8BAiABEvAjAZGgc/fjvDImEiCBgBMQ8olPrQ44A4ZPAiRAAr4jQHH33ZQyIBIgARJQa8vQufM8IAESIAHfERByxx9c5LuoGBAJkAAJBJyAkI9T3AN+DjB8EiABHxKguPtwUhkSCZAACQj581tWEQMJkAAJkIC/CFDc/TWfjIYESIAEbAJCbqdz57lAAiRAAn4jIOSTn1jpt6AYDwmQAAkEnQDFPehnAOMnARLwJQGKuy+nlUGRAAkEnYCQjzItE/STgPGTAAn4j4CQT3xyhf/CYkQkQAIkEGwCFPdgzz+jJwES8CkBIZ/YTOfu08llWCRAAsElIOSOjy0PbviMnARIgAT8SUDIxyju/pxaRkUCJBBkAhT3IM8+YycBEvAtASF//okLfRsdAyMBEiCBgBKguAd04hk2CZCAvwkIuZ3O3d9TzOhIgASCSEDI7R9mWiaIM8+YSYAEfE1AyCc3L/N1hAyOBEiABAJIgOIewElnyCRAAv4nIOQjdO7+n2ZGSAIkEDQCQj7xsaVBC5rxkgAJkIDfCVDc/T7DjI8ESCCQBIR84oN07oGcegZNAiTgZwJCPvbhJX4OkLGRAAmQQBAJUNyDOOuMmQRIwPcEKO6+n2IGSAIkEEQCIs60TBDnnTGTAAn4nICQj25e7PMYGR4JkAAJBI4AxT1wU86ASYAEgkBAyEc/QOcehJlmjCRAAoEiIOSTH7wgUBEzWBIgARIIAAGKewAmmSGSAAkEj4CQD9O5B2/aGTEJkIDfCQj5+IcX+T1IxkcCJEACQSNAcQ/ajDNeEiCBQBCguAdimhkkCZBA0AiIkYfez7RM0Gad8ZIACfiegJDbP7DQ91EyQBIgARIIGAGKe8AmnOGSAAkEgwDFPRjzzChJgAQCRkDIR25eELCYGS4JkAAJ+J4Axd33U8wASYAEgkiA4h7EWWfMJEACvicg5JMfmu/7KBkgCZAACQSMgJA/ex/FPWCTznBJgAT8T4Di7v85ZoQkQAIBJCDkYzfOC2DcDJkESIAEfE2A4u7r6WVwJEACQSVAcQ/qzDNuEiABXxMQ8qdMy/h6hhkcCZBAIAkI+ejNcwMZOYMmARIgAR8TEPLR6ynuPp5ghkYCJBBMAhT3YM47oyYBEvA5ASEfvmGOz2NkeCRAAiQQOAIU98BNOQMmARIIAgGKexBmmTGSAAkEjoCQT9w4O3BRM2ASIAES8DkBIR+iuPt8jhkeCZBAAAlQ3AM46QyZBEjA/wSEfOgapmX8P8+MkARIIGAEhHzsulkBi5nhkgAJkIDvCVDcfT/FDJAESCCIBIT8f3TuQZx4xkwCJOBvAkI+8t6Z/g6R0ZEACZBA8AhQ3IM354yYBEggAAQo7gGYZIZIAiQQPAJCPvT+zuCFzYhJgARIwN8EKO7+nl9GRwIkEFACQj50FZ17QCefYZMACfiXAMXdv3PLyEiABAJMQMjHr+0IcPwMnQRIgAR8SUDIBynuvpxZBkUCJBBoAhT3QE8/gycBEvArASG3b2r3a3CMiwRIgASCSoDiHtSZZ9wkQAK+JiDkj+ncfT3DDI4ESCCQBNQLsmcEMnIGTQIkQAI+JiDkwxsp7j6eYIZGAiQQTAIU92DOO6MmARLwOQGKu88nmOGRAAkEk4CQD17dFszQGTUJkAAJ+JcAxd2/c8vISIAEAkyA4h7gyWfoJEAC/iUg5GPXtfo3PEZGAiRAAsEkIOQDFPdgTj2jJgES8DMBirufZ5exkQAJBJaAkI9c0RLY6Bk4CZAACfiUAMXdpxPLsEiABIJNgOIe7Pln9CRAAj4lIOQ2pmV8OrcMiwRIIMAEhHxoY3OA42foJEACJOBLAhR3X04rgyIBEgg6AYp70M8Axk8CJOBLAkI+cHWTLyNjUCRAAiQQYAIU9wBPPkMnARLwLwGKu3/nlpGRAAkEmICQ29c3Bjh+hk4CJEACviRAcffltDIoEiCBoBMQchude9BPAsZPAiTgPwIUd//NKSMiARIgAQj5s3/TQA4kQAIkQAL+IkBx99d8MhoSIAESsAlQ3HkikAAJBJdApLES1W2dkGYzpDAhk2eAVD8SvYcwcjLxbgYj5E821r+bA+CxkwAJkMCkCZgxE7Udy2CEZwJCOPsbQFoK9Q9CaQkLw0gnuzFy5hQGD/dMeoxzvAPF/RxPAIcnARIoM4FISwXq2tYhZFZnRlaibm/p0UJv5zjSFpLJYzCtk+jrPoT4cLLMRz3p4Sjuk0bGHUiABN61BJLxENrXXIZQpCbj0t1grLQURkhI+/Os6mfFXrifK1efSg9BWoeQHO7FmXd6z0ceQj5xTd35eGA8JhIgARIoOoHwvAtgVs33+rWEFIadhwGUuLs/ev+4Zt4TdXevtJvGcXYDUlYakEeAoVOIn+qG7E8V/bin0KGQ27oo7lMAx11IgATeZQQa601ULNuAUMhQ7tyy0sLTZ6XmVjqUdeyeS3cy8bbwG2Ezz9Wr3Lwn+F46R2V20gMIpQ5h8GQv+vaePFeUKO7nijzHJQESKC+BxgvbUFm30nbpqbQjy7ZyK2ee/VV39U4DJdj5rt5QtYbZi4HaPe2KfTKd+QsAc29qw7N/8r3yBuqMRnE/F9Q5JgmQQPkJtK5dhlCkMyPemmDn5N8tJ+2ScfU5KRutouZsrl51svbPP4bE6e9i+8d/Ue6AhXzkktpyD8rxSIAESKDsBOrWXQFTRKy4cGy6lXXYtpC7am7n3r3f7Z8zX2ScuqHtMDpX77r6SHUEF/3nO4HUfjy+8o+A8r4XieJe9jOMA5IACZSbwHB0dqwy0r7Oya1r6RQ9z54pg3TlXBd7z8Z77dWFwd2yOm/k3JQVndctCM3e9EH7OjKwb6vxq1vL6t6F/N907uU+0TgeCZBAmQm0LZ2DaM0Cx7CHnBupBZ26e1PVE28DMKwJuPr8C4PqfNXnr0Lt/C41lLQS+8S/rPrDcrp3IR+8PFZmzByOBEiABMpLoGHlGoQjdbBc566lZOC5cSXkmh3PqZ7R3f6Y6Rz3wuDeaDUu+frtMKubM4EOdW/Fk58sm3unuJf3FONoJEAC5SZgCBN1qy6HGRJOZYxj23PSMxnnbapSxlH17pbQyiT1nHxidFs79VM9L2asuutzqmjFC1daif3i4WvvKFf4FPdykeY4JEAC54ZA9ZwWRBuWwTChatszT6BqTj3HpRfB1YsFH1ke6rj8faMC7n/nbuz41DPlACHkto015RiIY5AACZDAOSHQvnQxpDlDjW2Lu+nVtjvq7qVisk7egKqGyamasR262lFrL5ybqqOecFUPPK354/ejqmP5qHjTqf144Prby8GB4l4OyhyDBEjg3BFoX3EphBFWi4J5gp1Tw24LviPcdnmkp+Bu+sVw6h7dr7VKG8tN1aivVSrH3c8W+/X/5S6EwoWN88DRu7H9lqdLDYTiXmrC7J8ESODcEahuqUFt+0W2FVebu+yAbdc98daOzho50SDiJ5tC6ZHatIQIGRV9VrThJKLNfU4zx9WPFntl9Z2nWI2WVS1YfOuWMYNOW/vxwKaSu3chH1uZXfby3E0BRyYBEiCB4hOIXDoLRmSOnYqx73RqDyjZYu84bkumDKPvrcWwkpVWuP6YEak/pRYVE4nTDRg50xYKh4etqgVvIRRJ64uLqTbeQTtr0ISEseTT69C86rpxgxk4dDd+c+OO4gec7ZHiXkq67JsESODcEqi+fAXMUAxeCsVRcifvbv/s5tJP7r4QMpxC8+I37Y/ti4Cz1IBt1M+8vigtrbCsX/a6EQrLnHy89kCTWm/GWPOfPo6KpkXjBq7c+1MX31ZKOEL+gM69lIDZNwmQwDki0FxpILZmHfQyRnUottv2nmCSAkPdrUic7EDD8t8io/qu0U87K0daCREy+nevRKTpiFXdab+VyXkQSlsuWP0aqjBwyde/glAoctaoh4/ejR/fUDL3TnE/6wywAQmQwLuSQNPyZlS5DtqukHFvenqu3QvqxGurUNncjZr2k9k6eLe9d6NVtR050oihEzOt+mWvZlI8bl+ZJ147rpmNOe+bWC172noH//fiT5eKrZAPdVWVqnP2SwIkQALnjEBt1wKYVS0543ulkHbuxc2X9+68DE0rn4cwLce451XOZNpaJnp/ezGa1/6r3addLqkuGN7VIi2MJXesR+Py6yccc//RrfjFTSVx7xT3Cc8CG5IACbyrCDRcsgYww05du7fQl2bbvc96n78CLV2/hgzJ3LZK57X2yaSBEy9dhta1v7Jz+Jm8vXaT9sI7r0NswRUT5qTq3h+9vCTuneI+4VlgQxIggXcNAWN+NWJtF9rHqwQ656ZnntD37rwYNXNfh9k4OEqw9QtD/HQNBg4sQduanTn9eTdfVdsln7sG9Qs3ToqTqnt/5qafT2qfCTQWctv6ygm0YxMSIAESePcQaFrRgYrKzhwR9tIr+gNLSpBPvzUPsEzElr2t308dJeADbyxEKJRC7QX7bRCjbtSmBRbdshrNXR+ZFCgr9Q7+8fJPoSEiJ7XfWRpT3ItJk32RAAmcHwRmrlqCdLjGFmgvj667d+8oldAnhiI4tXstqtrfQvXMXucrE3CXF7B/HexuwtCRRWhcsQuIOC/A1l+zZ7c1gYZl9Vj6h1+ZNIThnq14+ENFde8U90nPAncgARI4vwlEDcxavgqW4T5gpL28OiPYeamaxMkY+veuQKTuCGILDkKELVvcZdLAmXdmIdnXjuo5r6GqtT8ndr0Cx7tBu+7uf4tw7fxJMVKVM9+7rKjuXcgdGysmdRBsTAIkQALnM4Hk/EZU1M6zDzHsHqgnvN5N0JQr+Or7lLtGTHIwijP75iM50GqnX+wtbcKs7kH1gn2orI47qRozpxx+VOpn1tVzMPO9n4P7Nr8Joxo6/jU8//EnJ9z+LA0p7sUiyX5IgATODwLhpXMQjjZmhFgdlS7m+ULvHbXn6i2EYI2EnbViKpKQwsmF65Uzekomp3LGvWgs+8x7UL/4hskBSb+D+6/4FFqiRcm9C/l9OvfJTQBbkwAJnNcE5i5fjnDE8eh63twWeK2GPb+U0XP53sVAz9XryxU4Sp+LICP2Wq5+yafXo+nC9wEhvefx0Q31fg3bNhfFvVPcz+uzlAdHAiQwKQLVLVVo71iU49S93Mx4Qu/ptefqR8mxVj6Z8yBUgfp53dXXzo9h9vXrUNW6AJFa9Q7XzEJjBeOS6QP40SduxWDPtN27kI8sjE4KHhuTAAmQwPlKoPayNoiatszN1PxlB/QFxHTzbefSXUVXDt8Td8/t62KvLzw2qq17ldArc7xxojMq0LlxMWJzFyLashyGWXi9d+v03Xh83bTdO8X9fD1JeVwkQAKTJ9B49QJYxuhlzFXlTH5qxRZ+92bqeEKvjsK+8eqmdfJdve7UC4l9oQtKKBxC/eoWtF+yEpWt8xCuXZhx9dI6gGeuvQXD3dNy7xT3yZ8+3IMESOB8JGDVGahftxTCLYHMCHLewXolkuenq1+MaMsyYOCe6bp3IbctO/vSlOfjRPKYSIAESEAnMOOSOqBulv1RIQetO249/65suZ5Gyezr2vmctspfe/XzWhWOPaipOXz3wNSYXh7f/ii/5r7AWjfK1ddd0I/X/3b3dCaY4j4detyXBEjg/CHQdlknwpX1uQcUzi2DzKlvd4VWvxBkku15SwTrqZV8sTfdq0b+BSL/KVcvvaP+zc/b29+Z2WNN9L2JnudPTgcuxX069LgvCZDA+UOg85oLgJQJRICUlb0pmjnCMYRefa8Ldr6r9/bPeRrVzdVPRujz00Rj3qQFcPj5XUCfNR24Qu7smngN5nRG4r4kQAIkUCoCx1sr0XjBXLv7ZFoofbc3JfLql5wadvWZZqPzSyRzKmW0p1xVJ57zt913gXVr8m/Meq7ea+/Fr56Kza+rd39PJOP9karnX58uKiG/Q3GfLkTuTwIkcI4JLF3aDFnfbB+FcAVd/azfUbRFP0+gbfF3hX4Msc2pmdfFXalz/oVAX54gx+lrpZYeqswNXfeK4KaHRgYHuiv27joyXaIU9+kS5P4kQAKjCVxwYxRvPhQvG5rlXbOBCmf5cl2Ak654RzSVVz8qofdEPaTd5NTFXjP3mT7HcvmFhN526276xr7o6OOoWnrtaqKXafb1vIaDbwxPlx3FfboEuT8JkIBDYNaSSpjRGtRU1QI1lej6s0UY2P8b/Oi2oyVFFIkZWLBiPnSR9tx77IIYqtuq0P3McfsYlNjrQu+5e1vsXVefk9LRFV6vd3cjGi9XP5arH0/o0+kEXv/lK8XgpRYOy1skoRjdsg8SIIFAEKifW4N4rAYJ1MI07fdEOyKaBC7+02WobGlBKvEWzrz6G+z+6lBJmJhLYzCjMzLi7Qn2zGtnoOOGu4FQFGmrFyO9L2Pk2BvY96PdSPQls+kWzUErYc84/3CBtWlcsS90w3bM3L1R4OauthqlLvYWTiD10oFicKK4F4Mi+yCBoBCI9QtYl9YibcVgVFYjhVCOoJuh7FOVc25qRecVzqvukE4iObALu//jy+h/c1pPXo5CHV3SBlTHRon7otvXoXHFnQWmJoHk0F6MHHsJp3fvRveOY3YbO+edV1+SEftw3o1aLa3jpXJGPblaaB15NU4BsfeefjVH9mLotb5inE5Cbi2yc18/K4rfHCx+rm0DgDPzK/HS3mnnoooBjn2QQOAIrO2Iob6tAyGEkHSjN62sUEsj83MCCUQqGkNY/WfvAULZC4C0+pDs+yX+6uMHi8Zvw7K5CIe1vxpMJ59eEzOx4q5Pway9FKHQ2O+tSCd7MXh4O178m6eyVTZ5N0D1FIudtnHF3gtCibP3eSZvr1XaFKqvtx279kCUtCSOHHkFe3rSxWAj5LbNWSjT6XHmvC6ExIOAbIHE9yGTd6G7OzGdLjP7zpp7O4T4K0DUQOKbOLh3a1H6ZSckQAITI9BSHUa4YYFTiaJEyxXytOfUE0gkgIj3uWqj/u9f8+VVqGppyRtEQibfweD+X+OxrdNzqZUNUdRWdCIadfLpasupkFFCX2NiwXVzUL/gYoRrl8OIzC4QtMTv/88f48RzpzIdZATbzdV7HY9y6m5dvTduphRzrMocvbxSu9GaSg7gyPHfT2xCzt6qeOI+e95PAaEtTi93Q8rP4+D+fz37YYzRYu7cFUiH/iuATVqLNBJDM3D06LSe3pryMXFHEggigZaWFlRHm+zQXUFX7lz9ly/oStMjaUf8U4s+2G62r1s+BjIL6ZHfYv+vduKl77tvPpok3MbWelRFGuy9PHFX69wmXfdeSOxbV9ej/fLViDYshVm9GkJEIVM9ePEbf4rkyexx6CWVExZ6d8CQV2Kp192PIfbuXwWD8ZEj1T09PZMkMGZzIbehOM591pd/ABH6g9yRpAWJHyNt3YND97444YOe8x82wBJ3IRR636hV8SVS6DvRhjPfm94Vf8IHw4YkQALo2NKpKmHsP8V1QXf/Nk8kEoi4+XZb3MOWVLnZaKTdRNdXNwJabj4fp8QgUn2/wk9bJu9aW77Qjgiyy5YnLJH5TQm8902Oq3c/tCtnmkx0rGtFz+unMNw94lwkhp0Hn/JX3fL+arGvWioN4zbw+vY+18siM23doJOG9oBVbgnmsZHTb7b1/dA5hiJsQspxoE9mgJ1fmgsr/CQgnHcX5mxSQorfAdaPAfk6ZHw3jDOH0dgzgKNzO2FWzAdCCyFCFwGh9wPoHGPoEaStf4f193x/MofGtiRAAtMk8Os7ZsCorbOF286tx+3/PCFXvdtiHnbTNAn1e8L5feXWVahsdapZxtus1CEM7f8lYosn9lf5fV0GLlo9ExUVgBJ1b1M/r/jqVQjXz0Oi5w0ceFTdxB2ynb2t69orLHTBVp97Qp1pq7W36+O11I8u6noZphJwfcuvq9crcrwUThxJXPHtN86GaDLfC7m1SOKuRn3vnQ2Q1d8FxM2TOYiJtZU7YYzcjof/ds/E2rMVCZBA0Qhc/8kapJrbE0lLqDSMLdxSq4xxB4rHE4Ar8FHVLg6IxsUVkQu3rIeIFH4xkBzux+CJ4xj47VHs+/UxPPnNidXFX/OBahjznVRRIiXg3TKds3ke2t7zjUzsUmUQkvsQ792J/r2v4u1/2Zu5d6AEPSeF4l0kolnnniPi6nvd+ecR1i8A6iv7Rqrr8L0LSebmqlZeE+o/he3fPVy0+VKp/KKKu3dk1//76wHzzwGxvggHuwfp1F+g+95t2IPillAV4eDYBQkEgcDTQGjj9XfNyzhXFbRj3p08TTgko2kl+s7m/BxHNOLeeG1cVYF5m5chWt9qN4if7sXQ0R4ce+4oju8egmo3MgJETYnD/+3QhP5f37ClEelwte3c7cOwHIHv2NCE2Td9CxCFK2SkdRqJgZcxfOxVHNj+Ek7+zkmF5OfqddHXr0u62Hu5fXvfQjd0VerHhaILvd5WfZ5IHMCv7+sv5rlUGnH3jnDTF9cDkbsA8QFkr6tnP36JEQj5M8j0d3Dwnh0Tmuiz98oWJEAC0yFw3WfbMWRUO+mXlJNTdwXdFvERJecqz54tibSHs79zB66qERCmQP+AhUjS+VwJutq8IudTh09iz/1nf+Bpwx91IFydLbOMe+69Aph9bRuaut6DSO1KGJELxnl3aQrWyD6MnNqJvt+9iv0P7LMvEl76xhNhXejVl5nKGP3GqevqdaG349eg5+ft1ZfplMTPv/2mulU9nenJ31fl3Md/YWsxRtt9axXiHVdB4koAcyHlAgjRDgl1l7sHkEcA8Xsg/Q5CeAqhvl+g6z7WsxeDPfsggWIR2LWlFvGovTiXI+Km47a9TRd1+zv3i6ghM8IdTWU/V19b3oVAuXb354G+YVz9g/Hz7ns2h9E/w/0rQImqa9INTWxV/8rV162KofWyi1DVvApm1WpA1I6JRLn65MCLGDi0C3u/+6Kd7lGbEuyEVoGji70qw/Q2PfdfyNXn5Phd4R9JDuGyvyvKU6l6XOUR92KdXOyHBEjg3BF4eqMBc2lujfjZBF25cv0CoCybt080mU2zVpgSnlePDKbRdd/4effnPhlDujWGKhfHiCvC9pUn7AiyWkZMF1ul/0ZDCDM3zUVs8cUwq1eM6+qHuu/Di9/aYfflJXiU2Ntarm7iumPmu3pP63OEfgxXLyzRP3jyeOxsF7MpzLqQKINzn8KBcRcSIIHzkMCzn+1A0swmGpRDV5tb1+64XFfQvb+9MxcA1517n3vpGGXr024/an8l8odePYnbnx77SfcdW5oQ1lYACymhrQRmbWxCw5qVOP322+h+oBtxzdV7YuusHekIdOOFtejccBGqmlbBqFoDIWoy1IeP/RNe+IsHs1U2eSl8e0x3U65eL7vMmHnN1eu5epWaUpv6bHjPPtzwaHEe+NROmdKnZM7D85OHRAIkMDUCcsdt9Yg01WVEXP2g0i8qf64nUscS7oqw69Bdm67+Ua7d26ywm38fGRI3fPtMoaO0i0A2fL4VqAaMZFbDTBHCpX/9DxCGk66RVg+SgzuROLEb+376Mob2Jhw7724qR+9t6mOr1sDc989Dw/y1EBDY892fYOhYIqeaRrXPiLom9t6FQ32kp2+ENoZed++OOxKXqcoN9+yb2myMvxfFvRRU2ScJ+JSA3LkljJGGdjs8S0urqN8LCboSc7XZWn4WQa9UbQcB9e/JM2lx5X0nCor7jtsqUNnhXGDUNuwKfDRi4NKv/xBCVI/aT8oE0onfIdX3Ak6/+TKOPtANO5Xjir0u9GrnSvdzvcTSa6O+sv8i0Esw81z9RMQ+ZIqBvv6+2KZ/cJYjLvJGcS8yUHZHAn4nIH/xxXbIkJkVc+W+k9mcecadjyHonju3RTThiL8t7O42oP4dABJvnBRXPj1qWQK54/M1iFRVwUugDEeyOjb/o4vQsOQmmNEu2Na+4CYhrROwhl/ASO8r2PeTl5E+EMeIm6sfJfT2AWZz7ErHCwm9albI1dsXAbdMU+VuPOEXKXGs/8SRGZt+OFiKc4biXgqq7JMEfExA7vhiPSqtGjud4t0EzU+3qPj1PPp4gm6LudLzgazIV0UkjvQPiRvvG1USKR/5Qi1qaqI5KRm1vy32NcBwQiBdZWLRhxeitv0SmDWrEDIWjFMOmYCVeBOp0y/g9Fsv4+iPD47p6m1DP46r12+ujif0qht1L2LdPfuFKM3zOxR3H/9PyNBIoBQE5CNfiGJGpfNk6ETSLbYeJuRod65SO3Et3x7J/lw1InEmmRLX3jdqDSn54B0x1DZEoVZwH0q4GlaTm3/Pd/Vt6xvQ0rUW0cZVZ3H1Klnfg9TgTowcfwX7fvpSyVz90NCwuPK/T+xp3ClMJMV9CtC4CwkEnYB8/sszkBgO2eLu3RBV7t1LMOj5cw+W59DHE3T1jKZy7d62/m9O5Ttb+eyXKjGUqEKsNivu4wn9mK6+81KYFasRCs89u6s/9RxOvfkyjv3kUNFcvRS94tLCN42LcX5R3ItBkX2QQMAIyJ99rgG10QpMJN2i8ud6O8sVb+XOvQfudUGHWySj/kkfHhQ3PJpTEim/0xXGivc4b16y/3pICNvFY0VX+xAAAAZESURBVIJin+/q269qQuuKLph1q2FG1ENOXvX86FmV1jEkB5/Hwfv/GcdfG7br7Keaq3+h/7D4zH3ea0+KfgZR3IuOlB2SgP8JHNy2uXJmy9y6gjdEW29uQf3CGQjXtWG47yh2/vXuDJGzCbon/DVRx70fN5Ni0z2jbjjKnVvqkLAMW9D1zUvTTNXVVzSbmHvDYlR2XDyuq0+e/ie8+o1t9tAjbrWOLfRjVODk5+qrZEqs+WZRFwrLP+so7v7//5ARkkDRCdjLljz72RbU1NiFLVj8oUbULFkAs7YdhpG7+uPenz2EfdsdgS7k0HVBPw0g5gq7ap8akoVSF3ZJ5rCRfeDIULn3AqsK2K7e/Twj/FqufjgqMlU3arzxXL0RUS/2cFz94NG/x8t/+XgWbBWyT8vqYj9GBU5oeEBc8fenij4xWocU91LSZd8k4GMCdtWMYYVRuyyCFVtuRCg0+sU/VuI0Xv7GY2joqkLzRe2w+gfxxr2HMa6gV7o5916H3nDTkLhy6+iSSJV7j0vnQlKvqm3ijp6pCviBAmI/XVevKnCWfuQCiJCBl/7HqznVOsqx68mcKveXsVz98PET4sr/WbQXcxQ6zSjuPv6fj6GRQCkJyGc3VyI+uxptM8NY+sUPZN+aZg0hNXAII8NxmGEDFfXtgKHk19l6nnscr/1zT8ahK/8ayxN027W7nyWPJ8cSQrtyJxyvQEMD0O+Kuy70qp9SuXr7wqM9Ias/LasvTaBUP7MGTlJA3Xhe880jAqUpgfQwU9xLefazbxLwMQH7LW5P3em8v3TxJxvQvLAdKRFCOFQJs64DhqE966+BOPP643jrfx3HwluaUT2nAyJSi2PP7cZvf9SHWk/k1borA46Dj6XSYu3oenevRztF9OgXIuiMmhiOGzCrHF0rJPalcvXewXhirwt9vqsPy7i45O/cP0tKd4JQ3EvHlj2TgO8JyCe21KG62rDdcde3NsFwX1Y9KvK0BSt+DJAjkDIFs3qmysBnmlmJw/jdl56A9yB+Y7+EVgEuJvEU587vbAl3rag2kQ6bqBDOeu/FdvVGNFc7Cz0t6wm9ek7WS8/Ybr/3zGTimepJRHGfKjnuRwIkADs1YzVXYNZlFZhzy4fykAwD8ROwLAmYYRgRtRa89m45rXVqZA/2bHleF3QkXBc/fEqKj94/pfc7yK1bQ1jXGz6vXH3P/h7x0futUp8+FPdSE2b/JOBjAnLbZgMtnTE7f77sT5YjUt0B2C9pSgOiGobZBITG0plhpOIHMXz4AHbdcwiJfpkR9KZTmQeZdr2yN7X2M7uKUg9+zl39cNwSV95bcEG0Yp8mFPdiE2V/JBAwAvJXX4nZeW6zQqDrS1cCkc6xEVinkRo+iIHuAzjwvR4kz0gcUa2PAE0V2SdT26vd1SQH0+LC+4u+1rkaMcfVHz9j2jdlx0rh2Ddl1TbNuvoaDIpVo+v2S3HKUNxLQZV9kkCACEh7Cd5YBJ03xzDzqpvzQpeAdRTJwW6cfvEAXvrHfjRVji/oqZhE4qjE8Z50oVUhS4W25K5elX8+c+9JsbW470odiwfFvVRnCvslgYAQkDs2mgivcypjLv3aFTCiHUD8ME71dOPIY93ofiaeSbfoDt1z5/sBzIxJvHRUYjMs4P50qVZKnOiUlMTVD+/pz19KYaLHM5V2FPepUOM+JEACOQTkY7eOXjvduyGq5c9RSNABCx+9P13quu+pTpn9KtKdW0wkpliBcwbYHz01NK/EDy3lx0dxn+qMcz8SIIEMAbltcwTzG8xx8+e2Qz8m0Xc8ja5dlhDlSU8Ue5rsm8g1M0y7AqdQrt50H6ZSA4dNC8OvDJUzveTFS3Ev9syzPxIIKAH5/Y0VWNziaIrn0FX+/K23gcphC888nS5XvrlcU5Dj6uNxA+ERcaIXaG6pS+165RdFq/KZSjwU96lQ4z4kQAIFCdj599aWEF4D0NKTxsanlUPPVsGQW9kIUNzLhpoDkQAJkED5CFDcy8eaI5EACZBA2QhQ3MuGmgORAAmQQPkIUNzLx5ojkQAJkEDZCFDcy4aaA5EACZBA+QhQ3MvHmiORAAmQQNkIUNzLhpoDkQAJkED5CFDcy8eaI5EACZBA2QhQ3MuGmgORAAmQQPkI/H9MmRf9fKuwHgAAAABJRU5ErkJggg==');
}

.multiple {
  margin: 3px 0px 0 8px;
  width: 47px;
  height: 16px;
  background-image: url('data:image/png;base64,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');
}
</style>
